<template>
    <div class="mt-20 mx-auto flex flex-col text-center">
        <span>Confirmation d'adhésion</span>
        <button class="mt-5 p-4 px-8 cursor-pointer bg-green-500 hover:bg-green-600 text-white rounded ml-auto disabled:opacity-75 disabled:cursor-not-allowed">Retourner à l'écran initial</button>
    </div>
</template>

<script>
export default {
    methods: {
        restart: function() {
            this.$emit('restart');
        }
    }
}
</script>